import { Link } from '@tanstack/react-router'

import { Button } from '@/components/ui/button'

/**
 * Catch-all 404 — never wrapped in `AppShell` because we may not
 * be authenticated when we get here (e.g. typed `/foo` in the
 * URL bar before logging in).
 */
export function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center bg-surface-muted">
      <p className="text-7xl font-bold text-brand">404</p>
      <h1 className="text-xl font-semibold text-text">Page introuvable</h1>
      <p className="text-text-muted max-w-xs">
        L'adresse demandée n'existe pas ou a été déplacée.
      </p>
      <Link to="/dashboard">
        <Button variant="primary" size="lg">
          Retour à l'accueil
        </Button>
      </Link>
    </div>
  )
}
